import React from 'react';
import { useSelector } from 'react-redux';
import './LoyaltyShortInfo.css';
import { GeneralLoyaltyDataService } from '../../services/general-loyalty-data.service';
import { RequestStatusesEnum } from '../../../../shared/src/enums/request-statuses.enum';

export const LoyaltyShortInfo = ({
    className = '',
}) => {
    const currentPlan = GeneralLoyaltyDataService.getLoyaltyPlan();
    const {
        data: loyaltyApiData,
        status: loyaltyApiRequestStatus,
    } = useSelector((state) => state.loyalty?.[currentPlan]) || {};

    if (loyaltyApiRequestStatus !== RequestStatusesEnum.SUCCEDED) {
        return null;
    }

    const currentLevelIndex = loyaltyApiData.currentLevelNumber;
    const levelName = GeneralLoyaltyDataService.getLevelName(currentLevelIndex);
    const pointsNumber = parseInt(loyaltyApiData.currentLevelPoints);
    const pointsTerm = GeneralLoyaltyDataService.getPointsTerminology();
    const cardImageSrc = GeneralLoyaltyDataService.getLevelCardImage(currentLevelIndex);

    return <div className={`loyalty-short-info ${className}`}>
        <div className="loyalty-short-info__text-wrapper">
            <div className="loyalty-short-info__level-name">{levelName}</div>
            <div className="loyalty-short-info__points-wrapper">
                <span className="loyalty-short-info__points-num">{pointsNumber}</span> {pointsTerm}
            </div>
        </div>
        <div className="loyalty-short-info__image-wrapper">
            <img src={cardImageSrc} alt="" className="loyalty-short-info__image" />
        </div>
    </div>;
};
